import { render, staticRenderFns } from "./applicationDebug.vue?vue&type=template&id=5878987b&scoped=true"
import script from "./applicationDebug.vue?vue&type=script&lang=js"
export * from "./applicationDebug.vue?vue&type=script&lang=js"
import style0 from "./applicationDebug.vue?vue&type=style&index=0&id=5878987b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5878987b",
  null
  
)

export default component.exports